import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "time-estimate" }
const _hoisted_2 = {
  key: 0,
  class: "time-estimate__data-icon iconfont itime"
}
const _hoisted_3 = { class: "time-estimate__data-text" }

import { computed, onMounted } from 'vue'
import type { DocListItem } from '@/models/interfaces'
import { readingMinutes } from '@/helpers/time'
import { Sentry } from '@/services/sentry'


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeEstimate',
  props: {
    doc: {},
    withIcon: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

onMounted(() => {
  if (!props.doc.summary_words) {
    Sentry.withScope((scope) => {
      scope.setExtra('doc_id', props.doc.id)
      Sentry.captureMessage('Doc missing summary_words')
    })
  }
})

const minutes = computed(() => readingMinutes(props.doc.summary_words))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.withIcon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, _toDisplayString(minutes.value) + " min", 1)
  ]))
}
}

})